import React from 'react';

import { Title } from '@/components/atoms/Title';
import { Button } from '@/components/atoms/Button';
import { Text } from '@/components/atoms/Text';
import { Link } from 'react-router-dom';
import { Routes } from '@/core/router/routes.types';
import Illustration from './NotFound.svg?react';
import { Container } from './NotFound.style';

const NotFound: React.FunctionComponent<React.PropsWithChildren> = () => {
    return (
        <Container>
            <Illustration width={390} />
            <Title text="Ooops..." weight="bold" />
            <Title text="notFound.message" weight="regular" />
            <Link to={Routes.Home}>
                <Button buttonType="outlinedPrimary">
                    <Text text="notFound.backToHome" />
                </Button>
            </Link>
        </Container>
    );
};

export default NotFound;
